import { render } from "./EditPersonPage.vue?vue&type=template&id=4f486dd5&scoped=true"
import script from "./EditPersonPage.vue?vue&type=script&lang=js"
export * from "./EditPersonPage.vue?vue&type=script&lang=js"

import "./EditPersonPage.vue?vue&type=style&index=0&id=4f486dd5&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f486dd5"]])

export default __exports__